export default __webpack_public_path__ + "static/media/BY.b8b701a1.svg";